import { render, staticRenderFns } from "./TextWithEditor.vue?vue&type=template&id=63e7d522&"
import script from "./TextWithEditor.vue?vue&type=script&lang=js&"
export * from "./TextWithEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports